import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'components/apollo';
import { Row, Column } from 'components/grid';
import classNames from 'classnames';
import Loader from 'components/loader';
import { appRoutes } from '../../../../app-routes';

const contentCols = {
  mobile: { size: 12, offset: 0 },
  tablet: { size: 12, offset: 0 },
  desktop: { size: 8, offset: 2 },
  largeDesktop: { size: 8, offset: 2 },
};

const UnregisterDelete = ({ match, deletePartner, success, error, loading }) => {
  const { personId } = match.params;

  const classes = classNames('unregister-delete');
  const contentClasses = classNames('unregister-delete-content');

  if (error) {
    return (
      <div className={classes}>
        <Container className={'unregister-mobile-container'}>
          <Row>
            <Column
              mobile={contentCols.mobile}
              tablet={contentCols.tablet}
              desktop={contentCols.desktop}
              largeDesktop={contentCols.largeDesktop}
            >
              <div className={contentClasses}>
                <p>Something went wrong. Please try again later or contact{' '}
                  <a href="mailto:PartnerBusinessSupport@afry.com">PartnerBusinessSupport@afry.com</a>.
                </p>
              </div>
            </Column>
          </Row>
        </Container>
      </div>
    );
  }

  if (success) {
    return (
      <div className={classes}>
        <Container className={'unregister-mobile-container'}>
          <Row>
            <Column
              mobile={contentCols.mobile}
              tablet={contentCols.tablet}
              desktop={contentCols.desktop}
              largeDesktop={contentCols.largeDesktop}
            >
              <div className={contentClasses}>
                <h2>Profile Deletion Request</h2>
                <p>
                  Your deletion request has been confirmed and will be processed shortly.
                  Should you decide to rejoin us in the future, we'd be delighted to welcome
                  you back—just{' '}
                  <Link to={`${appRoutes.register}/partner`}>click here</Link> to reapply.
                </p>
                <p>
                  If you have any questions or need assistance, our team is here to help.
                  Feel free to reach out to us at{' '}
                  <a href="mailto:PartnerBusinessSupport@afry.com">PartnerBusinessSupport@afry.com</a>.
                </p>
                <p>Wishing you all the best, 
                    <br />
                    AFRY Partner Network
                </p>
              </div>
            </Column>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className={classes}>
      <Container className={'unregister-mobile-container'}>
        <Row>
          <Column
            mobile={contentCols.mobile}
            tablet={contentCols.tablet}
            desktop={contentCols.desktop}
            largeDesktop={contentCols.largeDesktop}
          >
            <div className={contentClasses}>
              <h2>Profile Deletion Request</h2>
              <p>
                Thank you for being a part of the AFRY Partner Network. We've received
                your request to delete your profile, please confirm your request and it
                will be processed shortly.
              </p>
              <Button
                color="primary"
                onClick={() => deletePartner(personId)}
                disabled={loading}
              >
                {loading ? <Loader width={24} height={24} /> : 'Confirm deletion'}
              </Button>
              <p style={{ marginTop: '24px' }}>
                If you've reconsidered and would like to continue your journey with us,
                we'd be thrilled to have you stay. Simply click the link below to keep
                your profile active:
              </p>
              <p>
                <Link to={`${appRoutes.unregister}/remain/${personId}`}>
                  Regret and Remain in our PartnerNetwork
                </Link>
              </p>
              <p>
                Should you decide to rejoin us in the future, we'd be delighted to
                welcome you back—just{' '}
                <Link to={`${appRoutes.register}/partner`}>click here</Link> to reapply.
              </p>
              <p>
                If you have any questions or need assistance, our team is here to help.
                Feel free to reach out to us at{' '}
                <a href="mailto:PartnerBusinessSupport@afry.com">PartnerBusinessSupport@afry.com</a>.
              </p>
              <p>Wishing you all the best, 
                  <br />
                  AFRY Partner Network
            </p>
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

export default UnregisterDelete;